<template>
	<div>
		<div class="row">
			<div class="cols-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><a href="/item-table">{{ $t('product.catalogue') }}</a></li>
					<li><span>{{ $t('item.edit') }}</span></li>
				</ul>
			</div>
		</div>

		<div class="spinner-wrapper">
			<div class="spinner-border" role="status" v-if="spinner">
				<span class="sr-only">Loading...</span>
			</div>
		</div>

		<div v-if="!spinner">
			<div class="row" v-if="itemData">
				<div class="col-sm-12">
					<div class="sidebar">
						<button id="sidebar_save" @click="save" type="submit">
							<span uk-icon="save"></span>
							<span class="title">{{ $t('save') }}</span>
						</button>
						<button v-access:can="Const.PERMISSION_ROLE_EXPORT" onclick="$('#export-form').modal();"
								id="sidebar_export">
							<span uk-icon="upload"></span>
							<span class="title">{{ $t('export') }}</span>
						</button>
						<button id="sidebar_switch-default-value" type="submit" @click="enableDefaultValue = !enableDefaultValue">
							<span uk-icon="unlock"></span>
							<span class="title">{{ $t('switch.default.value') }}</span>
						</button>
						<button id="sidebar_drop-item-state"
								onclick="window.ClientSessionManager.dropItemState('${itemId}');" type="submit">
							<span uk-icon="close"></span>
							<span class="title">{{ $t('drop.item.state') }}</span>
						</button>
						<button id="sidebar_groups"
								@click="setTabsVisible()"
								:class="enableGroups ? 'sidebar_marked-button' : ''"
								type="submit">
							<span uk-icon="list"></span>
							<span class="title">{{ $t('enable.disable.groups') }}</span>
						</button>
						<button id="sidebar_help" type="submit">
							<span uk-icon="question"></span>
							<span class="title">{{ $t('help') }}</span>
						</button>
						<button id="sidebar_copy-attribute-name"
								onclick="editableTradeItem.setEnableCopyAttributeName()"
								:class="enableCopyAttributeName ? 'sidebar_marked-button' : ''">
							<span uk-icon="copy"></span>
							<span class="title">{{ $t('copy.attribute.name') }}</span>
						</button>
						<button id="sidebar_change-history">
							<span uk-icon="history"></span>
							<span class="title">{{ $t('change.history') }}</span>
						</button>
						<button id="sidebar_recalculate-attributes" @click="attributesRecalculate">
							<span class="fa fa-calculator"></span>
							<span class="title">{{ $t('recalculate.attributes') }}</span>
						</button>
						<button id="sidebar_copy-attributes-from-item">
							<span class="fa fa-paste"></span>
							<span class="title">{{ $t('copy.attributes.from.item') }}</span>
						</button>
					</div>
				</div>
				<div class="col-sm-12">
					<div class="form form-with-sidebar">

						<div id="dictionary-add-form">
							<div id="dictionary-value-area"><textarea id="new-dict-value" rows="2"></textarea></div>
							<button id="dictionary-save-button" class="button button-neutral">{{ $t('save') }}</button>
						</div>

						<div class="row">
							<div class="form-body">
								<tab-header class="row" :tabs-title="attributesGroups" :localization="localization" :activeTab="defaultTab"
											@current-tab="currentTab"/>
								<div class="row">
									<div class="col-sm-12">
										<div class="tab-content" :key="tabContentKey">
											<div class="tab-pane" :class="defaultTab === tab.title ? 'active': ''" v-for="tab in attributesGroups" :id="tab.title"
												 :key="tab.title">
												<div class="row" v-if="defaultTab === tab.title || openTabs.includes(tab.title)">
													<div class="row attributes-group-area">
														<div class="col-sm-12"><span>{{ tab.title }}</span></div>
													</div>
													<div v-for="itemCol in splitArr(tab.attributes)"
														 :class="'col-sm-' + 12 / countColumns">
														<AttributeBuilder
															v-for="item in itemCol"
															:key="item.title"
															:attribute-name="item.title"
															:is-value-key="isValueKey"
															:is-primary="itemPk"
															:prev-values-dictionary="prevValuesDictionary"
															:language="language"
															:localization="localization"
															:classificators="classificators"
															:measurement-units="measurementUnits"
															:item-config=itemsConfig
															:item=item
															:item-data="itemData"
															:enable-copy-attribute-name=enableCopyAttributeName
														/>
													</div>
												</div>
											</div>
											<div class="tab-pane" id="calculateTest">
												<div v-access:can="[Const.PERMISSION_ROLE_ADMIN]" class="row">
													<div ref="commandline" id="commandline"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div id="item-modifications" class="row"></div>
							</div>
						</div>

						<div v-access:can="Const.PERMISSION_ROLE_EXPORT" id="export-form" class="modal fade modal-window"
							 tabindex="-1" role="dialog" aria-labelledby="person-users-manager" aria-hidden="true">
							<div class="modal-dialog">
								<div class="modal-content modal-window_rect">
									<div class="export">
										<div class="row">
											<div class="col-sm-6">
												<div class="export-types">
													<ul id="export-types-list"
														class="nav nav-tabs nav-stacked attribute-groups"></ul>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="export-templates">
													<div id="export-templates-list" class="tab-content"></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				{{ $t('item.not.found') }}
			</div>
		</div>
	</div>
</template>

<script>

import { CONFIGURATIONS_ITEM_EDIT, UPDATE_ITEM_DATA } from 'actions/configurations'
import TabHeader from 'components/item-edit/TabHeader'
import { Fragment } from 'vue-fragment'
import { countColumns, mapAttrTabs, chunkTabAttribute } from '../services/shared'
import initItemHistory from 'components/item-history'
import { ItemProcessor } from '@/core/item_assistance/ItemProcessor'
import { initCopyAttributesFromItem, initSidebar } from '@/core/support_gui_components/sidebar/sidebar'
import {
	initTabAction,
	initTabAttributeContent
} from '@/core/item_assistance/initItemData'
import { initModificationInfoForEdit } from '@/core/item_assistance/itemAdditionals'
import { initDatepicker } from '@/core/input_controls/datepicker/datepicker'
import { initThreeStateCheckbox } from '@/core/input_controls/checkbox/checkbox'
import {
	enableAllHotkeysForAttributeEditors,
	enableAllHotkeysForAttributeGroups, enableHotkeyForDefaultValues,
	enableHotkeyForSave
} from '@/core/hotkey/HotkeyFunctions'
import {
	enablePrevValuesDictionarySupport
} from '@/core/support_gui_components/prevValuesDictionary/prevValuesDictionary'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import {
	disableLockableEditorsWithDefaultValues,
	getLocalizedMessage,
	removeTabindex,
	showMessageAlert
} from '@/core/shared'
import {
	attachRegistrationOfSelectedAttribute,
	isGroupMode, setFocusOnAttribute,
	setTabsVisible
} from '@/core/core_components/form/form'
import { bindResetButton } from '@/core/input_controls/button/button'
import { bindExportFormAction, configureExport } from '@/core/migration/ExportManager'
import { CopyToClipboard } from '@/core/shared'
import { attributesRecalculate } from '@/mixins/attributesRecalculate'
import CommandLineEditor from 'utils/mathtester'
import { flatDeepAttributes } from 'utils/format'

export default {
	name: 'ItemEdit',
	metaInfo () {
		return {
			title: this.$t('item.edit')
		}
	},
	components: {
		TabHeader,
		AttributeBuilder: () => import('components/item-edit/AttributeBuilder'),
		Fragment
	},
	mixins: [
		attributesRecalculate
	],
	props: [
		'id',
		'activeAttribute',
		'sourceItemId'
	],
	data () {
		return {
			attributesGroups: [],
			itemPk: [],
			localization: {},
			language: [],
			itemValidationRules: [],
			prevValuesDictionary: [],
			classificators: [],
			measurementUnits: [],
			itemStructure: [],
			decimalOrDigitSettings: '',
			countColumns: countColumns(),
			itemData: null,
			itemsConfig: [],
			itemsValidation: [],
			enableCopyAttributeName: false,
			enableGroups: false,
			defaultTab: '',
			openTabs: [],
			enableDefaultValue: false,
			activeAttribute2: null,
      tabContentKey: 0
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$store.commit('IS_CREATE_PAGE', false)
			vm.$store.dispatch(CONFIGURATIONS_ITEM_EDIT, `/items/${vm.id}/load`)
				.then(() => {
					vm.attributesGroups = vm.$store.getters.getAttributesGroups
					vm.itemPk = vm.$store.getters.getItemPk
					vm.language = vm.$store.getters.getLanguage
					vm.itemValidationRules = vm.$store.getters.getItemValidationRules
					vm.prevValuesDictionary = vm.$store.getters.getPrevValuesDictionary
					vm.classificators = vm.$store.getters.getClassificators
					vm.measurementUnits = vm.$store.getters.getMeasurementUnits
					vm.itemStructure = vm.$store.getters.getItemStructure
					vm.decimalOrDigitSettings = {
						decimalSeparator: vm.$store.getters.getPerson.decimalSeparator,
						digitGroupingPattern: vm.$store.getters.getPerson.digitGroupingPattern,
						digitGroupingSeparator: vm.$store.getters.getPerson.digitGroupingSeparator,
					}
					vm.itemsConfig = vm.$store.getters.getItemStructure

					if (vm.$store.getters.getItemData.length === 0) {
						showMessageAlert(getLocalizedMessage("error"), 'danger', getLocalizedMessage('item.not.found'));
						throw new Error(vm.$t('item.not.found'));
					} else {
						vm.itemData = vm.$store.getters.getItemData
					}
				})
				.then(() => {
					vm.setDefaultTab()
					vm.initEditableTradeItem()
				})
				.catch(errors => {
					console.error(errors)
					vm.rollbar.error('CONFIGURATIONS_ITEM_EDIT', errors)
				})
		})

	},
	computed: {
		spinner () {
			return this.$store.getters.getLoadingStatus
		}
	},
	methods: {
		initEditableTradeItem: function () {
			window.CopyToClipboard = CopyToClipboard

			window.editableTradeItem = new ItemProcessor()
			editableTradeItem.setItemId(this.id)
			editableTradeItem.setAttributesGroups(this.attributesGroups)
			editableTradeItem.setItemPk(this.itemPk)
			editableTradeItem.setLocalization(this.localization)
			editableTradeItem.setLanguage(this.language)
			editableTradeItem.setItemValidationRules(this.itemValidationRules)
			editableTradeItem.setPrevValuesDictionary(this.prevValuesDictionary)
			editableTradeItem.setClassificators(this.classificators)
			editableTradeItem.setMeasurementUnits(this.measurementUnits)
			editableTradeItem.setItemConfig(this.itemStructure)
			editableTradeItem.setItemData(JSON.parse(JSON.stringify(this.itemData)))
			editableTradeItem.loadSourceItemData(this.sourceItemId || '', this)
			editableTradeItem.setDecimalOrDigitSettings(this.decimalOrDigitSettings)

			this.activeAttribute2 = this.activeAttribute

			$(document).focus()
			initSidebar(['save', 'export', 'switch-default-value', 'groups', 'help', 'drop-item-state', 'copy-attribute-name', 'change-history', 'recalculate-attributes', 'copy-attributes-from-item'])
			initCopyAttributesFromItem(this)

			initTabAction()
			initModificationInfoForEdit(editableTradeItem.itemData)
			initTabAttributeContent()
			initThreeStateCheckbox('.form')

			window.ClientSessionManager.setItemConfig(editableTradeItem.itemConfig)

			//hotkeys
			enableAllHotkeysForAttributeGroups()
			enableAllHotkeysForAttributeEditors()
			enableHotkeyForSave()
			enableHotkeyForDefaultValues()

			//components
			enablePrevValuesDictionarySupport()
			enableMulticheckboxSupport()

			attachRegistrationOfSelectedAttribute(editableTradeItem)

			editableTradeItem.initItemAttributeControls(false, this.activeAttribute)

			bindResetButton()

			removeTabindex()

			editableTradeItem.unsavedDataManager.updateUnsavedDataSign()

			configureExport()
			bindExportFormAction(this.id, 'edit')

			let container = this.$refs.commandline
			if (container) {
				this.$nextTick(function () {
					new CommandLineEditor({
						container: container,
						math: this.$math,
						context: this
					})
				})
			}
		},
		isValueKey: function (itemKey, array) {
			for (let i = 0; i < array.length; i++) {
				if (itemKey === array[i]) {
					return true
				}
			}
			return false
		},
		setEnableCopyAttributeName: function () {
			this.enableCopyAttributeName = !this.enableCopyAttributeName
		},
		splitArr: function (arr) {
			let mapAttr = []
			mapAttrTabs(arr, mapAttr, this.itemsConfig, this.language)
			return chunkTabAttribute(mapAttr, arr)
		},
		save: function () {
			editableTradeItem.itemUpdate(this.updateState)
		},
		updateState: function (data) {
			this.$set(this, 'itemData', data)
			editableTradeItem.setItemData(JSON.parse(JSON.stringify(this.itemData)))
			this.$store.dispatch(UPDATE_ITEM_DATA, data)
		},
		setTabsVisible: function () {
			this.attributesGroups.forEach(a => {
				if (!this.openTabs.includes(a.title)) {
					this.openTabs.push(a.title)
				}
			})

			this.$nextTick(() => {
				const isGroup = !isGroupMode()
				setTabsVisible(isGroup)
				this.enableGroups = isGroup
			})
		},
		currentTab: function (tab) {
			if (!this.openTabs.includes(tab)) {
				this.openTabs.push(tab)
			}
			this.defaultTab = tab
			this.activeAttribute2 = null
		},
		setDefaultTab: function () {
			const attributesGroups = this.attributesGroups
			const activeAttr = this.activeAttribute
			let activeTab = attributesGroups[0].title

			if (!activeAttr) {
				this.defaultTab = activeTab
				this.openTabs = [this.defaultTab]
				return
			}

			attributesGroups.forEach(a => {
				let attr = flatDeepAttributes(a.attributes)
				if (attr.includes(activeAttr)) {
					activeTab = a.title
				}
			})

			if (activeTab) {
				this.defaultTab = activeTab
				this.openTabs = [this.defaultTab]
			}
		}
	},
	updated () {
		this.$nextTick(() => {
			if ($('.tab-content').length > 0) {
				initDatepicker()
				let tooltips = $('[data-toggle="tooltip"]')
				tooltips.tooltip('destroy')
				tooltips.tooltip({
					container: 'body'
				})

				if (!this.enableDefaultValue) {
					this.$nextTick(() => {
						disableLockableEditorsWithDefaultValues()
					})
				}
				if (this.activeAttribute2) {
					setFocusOnAttribute(this.activeAttribute2)
				}
			}
		})
	},
	created () {
		window.addEventListener('beforeunload', function (e) {
			let unsavedData = editableTradeItem.unsavedDataManager.getUnsavedData()
			if (JSON.stringify(unsavedData) !== '{}') {
				e.preventDefault()
				e.returnValue = ''
				return ''
			}
		})
		document.addEventListener('enableCopyAttributeName', this.setEnableCopyAttributeName)
		window.initItemHistory = initItemHistory
	}
}
</script>

<style scoped>
.spinner-wrapper {
	display: flex;
	justify-content: center;
}

.spinner-border {
	display: inline-block;
	width: 2rem;
	height: 2rem;
	vertical-align: text-bottom;
	border: .25em solid #ececec;
	border-right-color: transparent;
	border-radius: 50%;
	-webkit-animation: spin .75s linear infinite;
	animation: spin .75s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
